import { render, staticRenderFns } from "./VAllocateModal.vue?vue&type=template&id=58423644&"
import script from "./VAllocateModal.vue?vue&type=script&lang=js&"
export * from "./VAllocateModal.vue?vue&type=script&lang=js&"
import style0 from "./VAllocateModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports